import React from 'react';

const InfoSection = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-block border-b-4 border-[#0d6571] pb-2 mb-8">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Empowering Your Financial Future
            </h2>
          </div>
          <p className="text-lg text-gray-600 leading-relaxed">
            We combine cutting-edge technology with deep market expertise to deliver
            insights that matter. Our mission is to make complex financial information
            accessible and actionable for investors and business leaders.
          </p>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
